import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`;

const ReactionsContainer = styled.div`
  display: flex;
  gap: 8px;
  background: #4f4f4f;
  border-radius: 16px;
  padding: 4px 16px;
`;

const Reaction = styled.div`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-size: 20px;

  &:hover {
    scale: 1.3;
  }
`;

export default {
  Container,
  ReactionsContainer,
  Reaction,
};
